import { CSSProperties } from 'react';
import { EmailTemplateTipos } from './model/EmailTemplateTipos';

export { EmailTemplateTipos };

type IConfigEmailTemplateTipos = {
  id: EmailTemplateTipos;
  /** Indica si el EmailTemplate es visible desde la interfaz */
  hiddenBO: boolean;

  /** color principal de fondo */
  backcolor?: string;
  /** color de fuente */
  forecolor?: string;
  /** color de borde */
  bordercolor?: string;
}

export const ConfigEmailTemplateTipos : IConfigEmailTemplateTipos[] = [  
  // Emails del Sistema CNET
  { id: EmailTemplateTipos.NuevoUsuario, hiddenBO: false, backcolor: '#1ba1e2', forecolor: '#ffffff', bordercolor: '#006EAF' },
  { id: EmailTemplateTipos.ResetearContrasenia, hiddenBO: false, backcolor: '#6a00ff', forecolor: '#ffffff', bordercolor: '#3700CC' },
  { id: EmailTemplateTipos.Notificaciones, hiddenBO: false, backcolor: '#d80073', forecolor: '#ffffff', bordercolor: '#A50040' },
  { id: EmailTemplateTipos.Cumpleaños, hiddenBO: false, backcolor: '#a20025', forecolor: '#ffffff', bordercolor: '#6F0000' },

  // Emails de Clientes
  { id: EmailTemplateTipos.PrimerContacto, hiddenBO: false, backcolor: '#b1ddf0', forecolor: '#000000', bordercolor: '#10739e' },
  { id: EmailTemplateTipos.Comparativa, hiddenBO: false, backcolor: '#fad7ac', forecolor: '#000000', bordercolor: '#b46504' },
  { id: EmailTemplateTipos.Seguimiento, hiddenBO: false, backcolor: '#b0e3e6', forecolor: '#000000', bordercolor: '#0e8088' },
  { id: EmailTemplateTipos.CotizacionPedidoDescuento, hiddenBO: false, backcolor: '#bac8d3', forecolor: '#000000', bordercolor: '#23445d' },

  // Emails de sistema de Pagos
  { id: EmailTemplateTipos.ConfirmacionPago, hiddenBO: false, backcolor: '#60a917', forecolor: '#ffffff', bordercolor: '#2D7600' },
  { id: EmailTemplateTipos.PagoPendiente, hiddenBO: false, backcolor: '#6d8764', forecolor: '#ffffff', bordercolor: '#3A5431' },
  { id: EmailTemplateTipos.Voucher, hiddenBO: false, backcolor: '#008a00', forecolor: '#ffffff', bordercolor: '#005700' },
  { id: EmailTemplateTipos.ReenvioVoucher, hiddenBO: false, backcolor: '#006a00', forecolor: '#ffffff', bordercolor: '#003700' },
];

/** Todos los id's de Emails Templates */
export const AllEmailTemplateTipos = ConfigEmailTemplateTipos.map(p => p.id);

/** obtiene la configuración de un Email Template */
export const GetConfigEmailTemplateTipo = (estado?: EmailTemplateTipos) => ConfigEmailTemplateTipos.find(p => p.id === estado);

/** obtiene los estilos de un Email Template */
export const GetStyleEmailTemplateTipos = (tipo?: EmailTemplateTipos, def?: CSSProperties) => 
  ((cfg) : CSSProperties | undefined => !!cfg ? ({ backgroundColor: cfg?.backcolor, border: `1px solid ${cfg?.bordercolor}`, color: cfg?.forecolor }) : def)(ConfigEmailTemplateTipos.find(p => p.id === tipo));

export const GetTextEmailTemplateTipos = (tipo? : EmailTemplateTipos) : string =>
{
  if (!tipo) return "";
  if (typeof tipo === 'string') return `#${tipo}`;
  if (typeof tipo === 'number') return `@Entity#EmailTemplateTipo.Nombre.${tipo}`;
  return "";
}